import { AxiosError, AxiosRequestConfig } from 'axios';
import { apiDelete, apiPost } from './api';
const { REACT_APP_ORGANIZATION } = process.env;

type TDataKam = {
  organizationId: string | number;
  kamUserId: string | number;
};
export const assignKam = async (data: TDataKam) => {
  return apiPost<AxiosRequestConfig, TDataKam>(`${REACT_APP_ORGANIZATION}/organization/backoffice/kam/assign`, data)
    .then(resp => {
      const response: string = resp;
      return response;
    })
    .catch((error: AxiosError) => Promise.reject(error));
};

export const addKamToOrganization = async (data: TDataKam) => {
  return apiPost<AxiosRequestConfig, TDataKam>(
    `${REACT_APP_ORGANIZATION}/organization/backoffice/kam/add`,
    data
  )
    .then(resp => resp)
    .catch((error: AxiosError) => Promise.reject(error));
};

export const removeKamFromOrganization = async (data: TDataKam) => {
  const { organizationId, kamUserId } = data;

  return apiDelete<AxiosRequestConfig, string>(
    `${REACT_APP_ORGANIZATION}/organization/backoffice/kam/delete/${organizationId}/${kamUserId}`
  )
    .then(resp => resp)
    .catch((error: AxiosError) => Promise.reject(error));
};
